exports.onRouteUpdate = ({ location }) => {
  if (typeof window.gtag !== 'undefined') {
    gtag('config', 'UA-1789772-56', {
      // 'page_title' : document.title,
      'page_path': location.pathname
    });
  }
}


// WEBPACK FOOTER //
// ./gatsby-browser.js